
<template>
  <div>
    <printView :htmlDataList="htmlDataList" :showprint="showprint" v-if="showprint" :changeList="changeList" :modules="modules" @close="closeShow()"
      :btnLoading="btnLoading" :printData="printData" :printFun="printFun"></printView>
  </div>
</template>
  
<script>
import { print, printDataParse } from '@/utils/print';
import { modulesList, processModules } from './printModules'
export default {
  props: {
    isList: {
      type: Boolean,
      required: false,
      default: false
    },
    // 打印接口参数
    modules: {
      type: Number,
      required: false,
      default: 0
    },
    // 打印框显示
    showprint: {
      type: Boolean,
      required: false,
      default: 0
    },
    // table多选数据
    changeList: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    printFun: {
      type: Function,
      required: false,
      default: null
    }
  },
  data() {
    return {
      htmlDataList: '',
      btnLoading: false,
      printData: [],
      modulesList
    };
  },
  mounted() {
    this.getPrintData()
  },
  methods: {
    async getPrintData() {
      this.btnLoading = true
      processModules(this, this.changeList, this.modules, this.printFun, this.isList).then(res => {
        this.btnLoading = false
        this.printData = res
      });
    },
    closeShow() {
      this.$emit('close');
    }
  }
};
</script>
  
<style scoped>
.e-pr {
  width: 100%;
  top: 20%;
}
</style>
